app.directive('ajaxForm', function ($http, $log) {
    return {
        restrict: 'A',
        controller: function ($scope) {
        },
        link: function ($scope, $element) {
            var $form = $element.find('form');
            var $result = $('<div class="sg-newsletter-join-result"></div>');
            var $spinner = $('<i class="fa fa-spinner fa-spin invisible"></i>');
            $form.append($result);
            $form.prepend($spinner);

            $form.on('submit',function($event) {
                $event.preventDefault();

                $spinner.removeClass('invisible');
                $result.text('');

                $http({
                    method: 'POST',
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    responseType: 'json',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                }).then(function(httpResponse) {
                    $scope.resultMessage = httpResponse.data ? httpResponse.data.message : '';
                    $scope.resultType = 'success';
                    $form.find('input[type=email]').val('');
                }, function(httpError) {
                    $scope.resultMessage = httpError.data ? httpError.data.message : 'Error';
                    $scope.resultType = 'error';

                    if (httpError.xhrStatus !== "abort") {
                        $log.error(httpError);
                    }
                }).finally(function () {
                    $spinner.addClass('invisible');
                    $result
                        .removeClass('success')
                        .removeClass('error')
                        .addClass($scope.resultType)
                        .text($scope.resultMessage);
                    setTimeout(function () {
                        $result.text('');
                    }, 5000);
                });
            });
        }
    };
});
